import React, { Component } from "react";
import { connect } from "react-redux";
import { handleSignIn } from '../../store/actionCreators/authedUser';

class Login extends Component {
    state = {
        error: false,
        email: "",
        password: "",
        loading: false
    }

    handleChange = event => {
        this.setState({
            error: false,
            loading: false,
            [event.target.name]: event.target.value
        })
    }
    
    handleLogin = e => {
        e.preventDefault();
        this.setState({
            error: false,
            loading: true
        })
        this.props.dispatch(handleSignIn(this.state.email, this.state.password))
        .then(result => {
            if (result.error === null) {
                this.setState({
                    error: false,
                    loading: false
                })
            } else {
                this.setState({
                    error: true,
                    loading: false
                })
            }
        })
    }

    render() {
        // console.log(this.props)
        const { error, email, password, loading } = this.state;
        return (
            <div className="login p-0 m-0" style={{backgroundImage: "url(/images/login-background.png)"}}>
                <div className="row h-100 w-100 mx-0">
                    <div className="col-xl-5 login__sidebar h-100 p-2 p-lg-5">
                        <img src="./images/logoT.png" alt="Tracllo logo" width="100" height="auto" />
                        <div className="login-form container">
                            <h3 className="mb-5">تسجيل الدخول</h3>
                            <div className="alert alert-danger text-center mb-5 fs-5" role="alert" style={{display: error ? "block" : "none"}}>
                                البريد الإلكتروني أو كلمة المرور غير صحيحة
                            </div>
                            <form className="" onSubmit={this.handleLogin}>
                                <div>
                                    <input name="email" id="email" type="email" value={email} required onChange={this.handleChange} />
                                    <label htmlFor="email" alt="البريد الالكتروني" placeholder="البريد الالكتروني"></label>
                                </div>
                                <div>
                                    <input name="password" id="password" type="password" value={password} required onChange={this.handleChange} />
                                    <label htmlFor="password" alt="كلمة المرور" placeholder="كلمة المرور"></label>
                                </div>
                                <button type="submit" className="py-2 px-5" disabled={loading ? true : false} style={{cursor: loading ? "not-allowed": "pointer"}}>
                                    {loading
                                        ? <div className="spinner-border text-light" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        : "دخول"
                                    }
                                    
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect()(Login);
